//Country Selector
$(window).bind("load", function () {
    countryDropdown('#country');
});

function countryDropdown(seletor) {


    var Selected = $(seletor);
    var Drop = $(seletor + '-drop');
    var DropItem = Drop.find('li');


    $('.country_select').on('mouseleave', function () {
        Selected.toggleClass('close');
        Drop.toggle();
    });

    Selected.click(function () {
        Selected.toggleClass('open');
        Drop.toggle();
    });

    Drop.find('li').click(function () {

        Selected.removeClass('open');
        Drop.hide();

        var item = $(this);
        Selected.html(item.html());
        window.location.href = $(this).data('url')
    });

    DropItem.each(function () {
        var code = $(this).attr('data-code');

        if ( code != undefined ) {
            var countryCode = code.toLowerCase();
            $(this).find('i').addClass('flagstrap-' + countryCode);
        }
    });
}